
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenPad as ObiScreenPadElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-pad.js';
 
 
 

 
 export const ObiScreenPad = createComponent({
   react: React,
   tagName: 'obi-screen-pad',
   elementClass: ObiScreenPadElement,
   events: {
     
   }
  });
 
 